import React from 'react';
import Notification from './Notification';

const NotificationContainer = ({ notifications = [], onRemove }) => {
  // S'assurer que notifications est toujours un tableau
  const safeNotifications = Array.isArray(notifications) ? notifications : [];

  if (safeNotifications.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        maxWidth: '400px',
        width: 'auto',
        zIndex: 10000,
        pointerEvents: 'none'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', pointerEvents: 'auto' }}>
        {safeNotifications.map((notification, index) => (
          <div
            key={notification.id || index}
            style={{
              animation: 'slideIn 0.3s ease-out',
              animationDelay: `${index * 0.1}s`,
              animationFillMode: 'both',
              pointerEvents: 'auto'
            }}
          >
            <Notification
              message={notification.message || ''}
              type={notification.type || 'info'}
              onClose={() => onRemove && onRemove(notification.id)}
              duration={notification.duration || 5000}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationContainer;
